
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37.462 36.25a2.5 2.5 0 01-2.5 2.5H5.039a2.5 2.5 0 01-2.5-2.5V3.75a2.5 2.5 0 012.5-2.5h25a2.5 2.5 0 011.745.71l4.925 4.805a2.5 2.5 0 01.753 1.79V36.25z","fill":"#fff","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M13.789 16.25a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M31.355 30.333l-6.541-9.813a1.685 1.685 0 00-2.785-.032l-4.485 6.409-2.78-2.23a1.685 1.685 0 00-2.457.381l-3.518 5.285","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    